/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Coords } from './Coords'
import { CoordsFromJSON, CoordsFromJSONTyped, CoordsToJSON } from './Coords'

/**
 *
 * @export
 * @interface MapParams
 */
export interface MapParams {
  /**
   *
   * @type {string}
   * @memberof MapParams
   */
  markTitle: string
  /**
   *
   * @type {string}
   * @memberof MapParams
   */
  markSubtitle: string
  /**
   *
   * @type {Coords}
   * @memberof MapParams
   */
  coords: Coords
}

/**
 * Check if a given object implements the MapParams interface.
 */
export function instanceOfMapParams(value: object): value is MapParams {
  if (!('markTitle' in value) || value['markTitle'] === undefined) return false
  if (!('markSubtitle' in value) || value['markSubtitle'] === undefined)
    return false
  if (!('coords' in value) || value['coords'] === undefined) return false
  return true
}

export function MapParamsFromJSON(json: any): MapParams {
  return MapParamsFromJSONTyped(json, false)
}

export function MapParamsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MapParams {
  if (json == null) {
    return json
  }
  return {
    markTitle: json['markTitle'],
    markSubtitle: json['markSubtitle'],
    coords: CoordsFromJSON(json['coords']),
  }
}

export function MapParamsToJSON(value?: MapParams | null): any {
  if (value == null) {
    return value
  }
  return {
    markTitle: value['markTitle'],
    markSubtitle: value['markSubtitle'],
    coords: CoordsToJSON(value['coords']),
  }
}
